// Layout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { Toaster } from 'react-hot-toast'; // ✅ 新增
import './Layout.css';

const Layout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  return (
    <div className="layout">
      <Header />
      {/* 建议把 Sidebar 的开关交给 Navbar（见下方 props） */}
      <Navbar onToggleSidebar={() => setIsSidebarOpen(v => !v)} />
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

      <main className="layout-main">
        <div className="layout-content">
          <Outlet />
        </div>
      </main>

      {/* ✅ 全局一次性 Toaster。若有固定 Header，给个 top 偏移 */}
      <Toaster
        position="top-right"
        containerStyle={{ top: 64 }}   // 按你的 Header 实际高度调整
        toastOptions={{ duration: 4000 }}
      />
    </div>
  );
};

export default Layout;
